import { useContext } from "react";
import UserContext from "../Contexts/UserContext";
import { Navigate } from "react-router-dom";

function LoginRoute({ children }) {
  const { user, isLoading, setIsLoading, setUser } = useContext(UserContext);

  return !user.id ? children : <Navigate to={"/"} />;
}

export default LoginRoute;
